import React from 'react';
import PropTypes from 'prop-types';
import {Switch, Route} from 'react-router-dom';
import {lightRoutes} from './light.config';
import {darkRoutes} from './dark.config';

export const AppRoute = props => {
  const routes = props.light ? lightRoutes : darkRoutes;
  return (
    <Switch>
      {routes.map((route, i) => (
        <Route
          key={i}
          {...route}
        />
      ))}
    </Switch>
  );
};

AppRoute.propTypes = {
  light: PropTypes.bool
};



// WEBPACK FOOTER //
// ./routes/Route.js